import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Record, Map } from 'immutable';
import styled from 'styled-components';
import {
  DEVICE_ORIENTATION,
  CANVAS_SCALE,
  DEVICE,
  IMAGE,
  FRAME,
  NAME,
  SRC,
} from 'PreviewConstants/';
import {
  LEFT,
  TOP,
  HEIGHT,
  WIDTH,
  UI,
} from 'SharedConstants/';

const negateNumber = number => number * -1;

const Image = styled.img`
  position: absolute;
  pointer-events: none;
  left: ${props => negateNumber(props.left)}px;
  top: ${props => negateNumber(props.top)}px;
`;

const DeviceImage = ({
  deviceSrc,
  deviceName,
  deviceImage,
  deviceFrame,
  canvasScale,
}) => {
  const size = [WIDTH, HEIGHT].reduce((memo, pos) =>
  ({
    ...memo,
    [pos]: deviceImage.get(pos) * canvasScale,
  }), {});

  const position = [LEFT, TOP].reduce((memo, pos) =>
  ({
    ...memo,
    [pos]: deviceFrame.get(pos) * canvasScale,
  }), {});

  return (
    <Image
      {...{
        ...size,
        ...position,
      }}
      src={deviceSrc}
      alt={`${deviceName} device image`}
    />
  );
};

DeviceImage.propTypes = {
  deviceSrc: PropTypes.string,
  deviceName: PropTypes.string,
  deviceImage: PropTypes.instanceOf(Map),
  deviceFrame: PropTypes.instanceOf(Record),
  canvasScale: PropTypes.number,
};

DeviceImage.defaultProps = {
  deviceName: '',
  deviceSrc: '',
  deviceImage: new Map({}),
  deviceFrame: new Record({}),
  canvasScale: 1,
};

const mapStateToProps = (state) => {
  const device = state.getIn([UI, DEVICE]);
  const deviceOrientation = state.getIn([UI, DEVICE_ORIENTATION]);
  return {
    deviceSrc: device.getIn([deviceOrientation, SRC]),
    deviceName: device.get(NAME),
    deviceImage: device.getIn([deviceOrientation, IMAGE]),
    deviceFrame: device.getIn([deviceOrientation, FRAME]),
    canvasScale: state.getIn([UI, CANVAS_SCALE]),
  };
};

export default connect(mapStateToProps)(DeviceImage);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/ResizableContainer/DeviceImage.jsx